import { Parcel } from "../../../../services/parcelTypes";
import { formatDateTime, formatLatLon } from "../../../../utils/parcelFormatters";
import {
    Field,
    safeText
} from "../ParcelFields";
import { ParcelSection } from "../ParcelSection";

export function ParcelMetadataSection({
    parcel,
}: {
    parcel: Parcel;
}) {

    const city = parcel?.address?.city?.trim();
    const state = parcel?.address?.state?.trim();
    const zip = parcel?.address?.zip?.trim();

    const cityStateZip = [
        city,
        [state, zip].filter(Boolean).join(" "),
    ]
        .filter(Boolean)
        .join(", ");

    return (
        <ParcelSection
            title="Metadata"
            icon={
                <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
            }
            collapsible
            defaultExpanded={false}
        >
            <Field label="Last Updated" value={formatDateTime(parcel.lastUpdatedAt ?? undefined)} />
            <Field label="Coordinates" value={formatLatLon(parcel.location?.lat ?? undefined, parcel.location?.lon ?? undefined)} />
            <Field label="Address" value={safeText(parcel.address?.situs)} />
            <Field label="Location" value={safeText(cityStateZip)} />
        </ParcelSection>
    );
}